module.exports = __webpack_public_path__ + "static/media/custom-filter.79249700.svg";